/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *    .       .       .       .       .       .       .       .       .       .       .       .
 *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *      ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *   . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *        .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *   .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *
 * Copyright FortyFix(c) 2024.
 * Title: Marketing.ts;
 * Path: /Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/GESFF_Gestionale_FF_Angular/src/environments/Modules/Marketing.ts;
 * Description: ;
 * Author: giovannibattistadellaporta;
 * Created at: 27/08/2025;
 */



import {NewsComponent} from "../../app/task/news/news.component";
import {TaskService} from "../../app/task/_service/task.service";
import {CampoAggiuntivo} from "../../app/shared/models/campo-aggiuntivo";
import {Permission} from "../../app/Login/_guards/Permission";
import {ApiPathsService} from "../../app/api-paths.service";
import {LISTComponent} from "../../app/task/list/list.component";

// export function CRM() {
//     return {
//         enabled: true,
//         label: "CRM",
//         Campi: [
//             {
//                 nome: 'Attività',
//                 oggetti: ['attivita'],
//                 modificabile: true,
//                 class: "col-lg-12",
//                 required: true
//             },
//             {
//                 nome: 'Data',
//                 oggetti: ['data_attivita'],
//                 modificabile: true,
//                 inputType: 'datetime-local',
//                 class: "col-lg-12",
//                 required: true
//             },
//             {
//                 nome: 'Data di chiusura',
//                 oggetti: ['data_chiusura'],
//                 hideif: {fieldnotexist: 'data_chiusura'},
//                 disabledif: {fieldexist: 'data_chiusura'},
//                 modificabile: true,
//                 inputType: 'datetime-local',
//                 class: "col-lg-12",
//             },
//             {
//                 nome: 'Attività conclusa',
//                 oggetti: ['att_chiusa'],
//                 modificabile: true,
//                 inputType: 'checkbox',
//                 class: "col-lg-12",
//             },
//             {
//                 prevDivClass: "col-md-12 mt-3",
//                 modificabile: true,
//                 nome: 'Allegato',
//                 oggetti: [null],
//                 inputType: 'file',
//                 class:"col-lg-3",
//                 placeholder: '(pdf,doc,docx,xls,xlsx,jpg,png,txt,ods,odt) Size Limit: 5.00 MB',
//                 visibleifProhibited: true
//             },
//             {
//                 nome: 'Note:',
//                 oggetti: ['note'],
//                 modificabile: true,
//                 inputType: 'textarea',
//                 class: "col-lg-12",
//             },
//             {
//                 url:'/anagrafica/clienti/attivita/types',
//                 nome: 'Tipologia',
//                 internalOutput: 'tipoObject',
//                 oggetti: ['tipo'],
//                 OutputField: 'tipo',
//                 inputType: 'singleDropdown',
//                 visibleifProhibited: false,
//                 modificabile: true,
//                 settings: {
//                     singleSelection: true,
//                     closeDropDownOnSelection: true,
//                     singleOutput: true,
//                     idField: 'id',
//                     textField: 'label',
//                     searchPlaceholderText: "Cerca",
//                     allowSearchFilter: true,
//                     allowRemoteDataSearch: true,
//                 },
//                 class: 'col-lg-12',
//             },
//             {
//               nome: 'Responsabile',
//               source: '/anagrafica/persone/list',
//               responseHasData: true,
//               parameter: [{ nome: "page", value: 1 }, { nome: "size", value: 200 }],
//               internalOutput: 'responsabile',
//               oggetti: ['resp_attivita'],
//               OutputField: 'resp_attivita',
//               OnChange: 'OnOperatoreChange',
//               /*OnFilter: 'filtroManager',*/
//               modificabile: true,
//               inputType: 'singleDropdown',
//               disabledif: { hasRoles: ['OP', 'AS', 'PS'] },
//               placeholder: 'Seleziona',
//               settings: {
//                 singleSelection: true,
//                 closeDropDownOnSelection: true,
//                 singleOutput: true,
//                 idField: 'id',
//                 textField: 'fullName',
//                 searchPlaceholderText: "Cerca",
//                 allowSearchFilter: true,
//                 allowRemoteDataSearch: true,
//               },
//               class: 'col-lg-12',
//               visibleifProhibited: false
//             },
//         ],
//         Headers: [
//             {
//                 nome: 'Attività',
//                 oggetti: ['attivita'],
//
//             },
//             {
//                 nome: 'Data',
//                 oggetti: ['data_attivita'],
//                 inputType: 'datetime-local',
//             },
//             {
//                 nome: 'Data di chiusura',
//                 oggetti: ['data_chiusura'],
//                 inputType: 'datetime-local',
//             },
//             {
//                 nome: 'Stato', type: 'html', printable: false, oggetti: ['att_chiusa'], func: (oggetto, parent) => {
//                     var Aperta = `
//                         <a href="javascript:void(0)" tooltip="Aperta" class=" status-icon link font-16 text-danger font-weight-bold" >
//
//                             <span class="tooltiptext"> Aperta</span>
//                         </a>
//                     `
//                     var chiusa = `
//                         <a href="javascript:void(0)" class=" status-icon link font-16 text-danger font-weight-bold" >
//
//                             <span class="tooltiptext"> Scaduta</span>
//                         </a>
//                     `
//                     if (oggetto.att_chiusa)
//                         return [chiusa,];
//                     if (!oggetto.att_chiusa)
//                         return [Aperta,];
//                     else return [];
//
//                     // return [{ component: Alert, params: { tooltip: 'In scadenza', aclass: null, iclass: null, color: null } }];
//                 }
//             },
//         ],
//         Capacita: [],
//         Azioni: [],
//         SaveMap: (x) => {
//           var value = Object.assign({}, x);
//             if (typeof value.allegato == 'number') value.allegato = null;
//             if (x.att_chiusa && !x.data_chiusura) value.data_chiusura = new Date().toISOString().slice(0, 16);
//
//             return value;
//         },
//     }
// }
export var CrmTask: any = () => {
    return {
        type: 'C',
        addButton: false,
      Buttons:[
        {
          nome: 'Aggiungi',
          close: false,
          class: ' btn ',
          labelClass: 'ml-1 text-info font-weight-bold',
          type: 'func',
          hideif:{func: (x)=>{  console.log("if data: ", x); return x.clienteObject && ( x.clienteObject?.lead || x.clienteObject?.isCliente)}},
          func:(x:{filter:{cliente?: number, filtro:any,persona?:number, component:LISTComponent}}, api:ApiPathsService,z)=>{
            api.ClassicPost("/anagrafica/clienti/get",{id:x.filter.cliente}).subscribe(
              cliente=>{
                x.filter.component.router.navigate(['navigate', cliente.contatto && cliente.lead && cliente.isCliente?  'care':'pre-sales'], {queryParams:{cliente: cliente.id, fullname: cliente.fullName}})
              }
            )



          },
          icon: 'fas fa-chevron-right text-info',
          placeholder: '',
        },
      ],
        managerLoggato: { },
        hideif: {  },
        afterAddMap:(task:any, component:TaskService)=>{

          var newTask = {tipo: task?.tipoObject['id'], tipoObject:task?.tipoObject}
            if (task.id) {
              task = newTask;
            }
            return task;
          },
        restRoute: '/anagrafica/clienti/attivita',
            Label: '',
            OnSaveMap: (task) => {
                task['resp_attivita'] = task?.managerObject['id'];
                if (task.att_chiusa && !task.data_chiusura) task.data_chiusura = new Date().toISOString().slice(0, 16);
                return task;
            },
            Map: (task) => {
                task['tipo'] = task?.tipoObject['id'];
                return task;
            },
      onCloseGoTo: (x:NewsComponent, response:any)=> {
          if(response?.response?.cliente && response?.response?.id)
            return "/marketing/add-account/"+(response?.response?.cliente) + "?tab=Attività"
          else if(x.Item?.qs?.cliente)
            return "/marketing/add-account/"+(x.Item?.qs?.cliente) + "?tab=Attività"
        return "/marketing/database-clienti"
      },
        Headers: [
         {
                nome: 'Cliente',
                oggetti: ['clienteObject.fullName'],
                hideif:{func: (x)=>{console.log(x); return !x?.cliente}}
            },
          { nome: "Tipo", oggetti: [ 'tipo', ], type: 'replace', replacement: [ { original: 235, replace: "Call su lead" }, { original: 239, replace: "Meeting su Lead" }, { original: 237, replace: "Call su Acquirente" }, { original: 236, replace: "Meeting su Acquirente" }, { original: 238, replace: "Supporto" }, { original: 250, replace: "Invio Contratto / Preventivo" }], color: [] },

          {
                nome: 'Attività',
                oggetti: ['nome'],

            },
            {
                nome: 'Data',
                oggetti: ['data_inizio_prevista'],
                inputType: 'datetime-local',
            },
            {
                nome: 'Data di chiusura',
                oggetti: ['data_fine_prevista'],
                inputType: 'datetime-local',
            },
            {
                nome: 'Stato', type: 'html', printable: false, oggetti: [''], func: (oggetto, parent) => {
                    var Aperta = `
                        <a href="javascript:void(0)" tooltip="Aperta" class=" status-icon link font-16 text-danger font-weight-bold" >

                            <span class="label label-danger"> Aperta </span>
                            <span class="tooltiptext"> Aperta</span>
                        </a>
                    `
                    var chiusa = `
                        <a href="javascript:void(0)" class=" status-icon link font-16 text-danger font-weight-bold" >
                             <span  class="label label-success"> Chiusa </span>
                            <span class="tooltiptext"> Chiusa</span>
                        </a>
                    `
                    if (oggetto.data_fine_prevista)
                        return [chiusa,];
                    if (!oggetto.data_fine_prevista)
                        return [Aperta,];
                    else return [];

                    // return [{ component: Alert, params: { tooltip: 'In scadenza', aclass: null, iclass: null, color: null } }];
                }
            },
        ],
        campi: [
          {
            nextDivClass: 'col-lg-12',
            nome:'',
            hideif: {func: (x) => x.qs?.cliente},
            modificabile: false,
            style:{"color": "var(--main-color)", fontSize: "20px", "font-weight": 500},
            oggetti: ['tipo', '-', 'fullname'],
            type: 'replace',
            replacement: [
              {original: '-', replace: '-'},
              { original: 237, replace: 'Call' },
              { original: 236, replace: 'Meeting' },
              { original: 238,  replace: 'Support' },
              { original: '237', replace: 'Call' },
              { original: '236', replace: 'Meeting' },
              { original: '238',  replace: 'Support' },
              { original: '235', replace: 'Call' },
              { original: '239', replace: 'Meeting' },
              { original: '250',  replace: 'Support' },
              { original: 235, replace: 'Call' },
              { original: 239, replace: 'Meeting' },
              { original: 250,  replace: 'Support' },

            ]
          },
            {
                nome: 'Lead',
                url: '/anagrafica/clienti/list',
                responseHasData: true,
                parameter: [{ nome: "page", value: 1 }, { nome: "size", value: 10 }, {
                  nome: "ruolo",
                  value: 'C',
                }, {nome: 'classificazione', value: ['CL']},{nome:"nome", search:true}, {nome: "light", value: true}],
                oggetti: ['cliente'],
                internalOutput: 'clienteObject',
                OutputField: 'cliente',
                OnChange: 'OnClienteChange',
                modificabile: true,
                inputType: 'singleDropdown',
                placeholder: 'Seleziona un Cliente Lead',
                hideif: { func:(task)=>{return [235,239,"239", "235", "250", 250].includes(task.tipo ?? task.tipoObject?.id ?? 0) && !task.id && !task?.qs?.cliente }},
                settings: {
                  singleSelection: true,
                  closeDropDownOnSelection: true,
                  singleOutput: true,
                  idField: 'id',
                  textField: 'fullName',
                  searchPlaceholderText: "Cerca",
                  responseHasData:true,
                  allowSearchFilter: true,
                  allowRemoteDataSearch: true,
                  allowPagination:true,
                  page:1,
                  size:10
                },
                class: 'col-lg-3',
                visibleifProhibited: true
            },
            {
                nome: 'Acquirente',
                url: '/anagrafica/clienti/list',
                responseHasData: true,
                parameter: [{ nome: "page", value: 1 }, { nome: "size", value: 200 }, {
                  nome: "ruolo",
                  value: 'C',
                }, {nome: 'classificazione', value: ['CC']}, {nome:"nome", search:true}, {nome: "light", value: true}],
                oggetti: ['cliente'],
                internalOutput: 'clienteObject',
                OutputField: 'cliente',
                OnChange: 'OnClienteChange',
                modificabile: true,
                inputType: 'singleDropdown',
                placeholder: 'Seleziona un Cliente Acquirente',
                hideif: { func:(task)=>{return [236,237,238,"236","237","238"].includes(task.tipo ?? task.tipoObject?.id ?? 0) && !task.id && !task?.qs?.cliente }}, //Customer care Meeting
                settings: {
                  singleSelection: true,
                  closeDropDownOnSelection: true,
                  singleOutput: true,
                  idField: 'id',
                  textField: 'fullName',
                  searchPlaceholderText: "Cerca",
                  responseHasData:true,
                  allowSearchFilter: true,
                  allowRemoteDataSearch: true,
                  allowPagination:true,
                  page:1,
                  size:10
                },
                class: 'col-lg-3',
                visibleifProhibited: true
            },
            {
                nome: 'Attività',
                oggetti: ['attivita'],
                modificabile: true,
                class: "col-lg-3",
                required: true
            },


            {
                nome: 'Data',
                oggetti: ['data_attivita'],
                modificabile: true,
                inputType: 'datetime-local',
                class: "col-lg-3",
                required: true
            },
            {
                nome: 'Data di chiusura',
                oggetti: ['data_chiusura'],
                hideif: { fieldnotexist: 'data_chiusura' },
                disabledif: { fieldexist: 'data_chiusura' },
                modificabile: true,
                inputType: 'datetime-local',
                class: "col-lg-4",
            },
            {
                nome: 'Attività conclusa',
                oggetti: ['att_chiusa'],
                modificabile: true,
                inputType: 'checkbox',
                class: "col-lg-3",
            },
            {
                prevDivClass: "col-md-12 mt-3",
                modificabile: true,
                nome: 'Allegato',
                oggetti: [null],
                inputType: 'file',
                class: "col-lg-3",
                placeholder: '(pdf,doc,docx,xls,xlsx,jpg,png,txt,ods,odt) Size Limit: 5.00 MB',
                visibleifProhibited: true
            },
            {
                nome: 'Note:',
                oggetti: ['note'],
                modificabile: true,
                inputType: 'textarea',
                class: "col-lg-12",
            }

        ],
        Azioni: [
            {
              nome: 'Elimina',
              close: true,
              class: ' btn ',
              labelClass: 'ml-1 text-danger font-weight-bold',
              type: 'POST',
              restRoute: '/anagrafica/clienti/attivita/delete',
              preAlert: 'Sei sicuro di voler eliminare questo elemento?',
              // capacita: ['gestione-valutazioni'],
              icon: 'fas fa-trash text-danger',
              hideif: {fieldnotexist: 'id'},
              placeholder: 'Elimina',
              successMex: 'Elemento eliminato con successo',
              parameter: [{nome: "id", parameter: 'id'}]
            },
        ]

    }

}


export function Marketing(Menu? : any) {
    return {
        Modules: {
            "Marketing": true,
            "Clienti": true,
            "Progetti": true
        },
        Marketing: {
            data_ordine: 'data_accettazione'
        },
      filtrife:[    { id: "C", label: "Attivita Cliente", capacita: [], module: undefined, tipo:'C' }],

        TaskAddon: {
            //Crm: CRM(),
            DynamicFields: [CrmTask()],
            hideDateFilter: true,
            sidebarFilter: [
                { nome: "Inizio", oggetti: ['inizio'], modificabile: true, inputType: 'date', class: 'col-lg-12' },
                { nome: "Fine", oggetti: ['fine'], modificabile: true, inputType: 'date', class: 'col-lg-12' },
            ],
            ListTableHeaderField: [
                { nome: "Tipo", oggetti: ['type', 'tipo', ], type: 'replace', replacement: [{ original: 'M', replace: 'Lead' }, { original: 'Q', replace: 'Contatto' }, { original: 'C', replace: '' }, { original: 235, replace: "Call su lead" }, { original: 239, replace: "Meeting su Lead" }, { original: 237, replace: "Call su Acquirente" }, { original: 236, replace: "Meeting su Acquirente" }, { original: 238, replace: "Supporto" }, { original: 250, replace: "Invio Contratto / Preventivo" }], color: [] },
                { nome: "Data", oggetti: ['data_inizio_prevista'], inputType: 'datetime-local', color: [] },
            ],

        },

        ProdottiAddon: {
            hideAccettato: true
        },

        Menu: Menu ?? [
            {

                module: "Clienti",
                path: "marketing/database-clienti",
                title: "Database",
                icon: "mdi mdi-headset",
                capacita: ["menu-clienti"],
            },
            {
                id: 'att',
                module: "Clienti",
                path: "clienti",
                title: "Attività",
                class: "has-arrow",
                icon: "mdi mdi-calendar-clock",
                capacita: ["menu-scadenzario"],
                submenu: [
                    {
                        id: 'registrazione',
                        module: "Clienti",
                        path: "clienti/pre-sales",
                        title: "Registrazione",
                        icon: "mdi mdi-bullhorn",
                        class: 'has-arrow',
                        capacita: [],
                        submenu: [
                            {
                                id: 'contatto',
                                module: "Clienti",
                                path: "navigate/contatto",
                                title: "- Contatto",
                                icon: "mdi mdi-account-group",
                                htmlText: '',
                                capacita: ["menu-clienti"],
                                class: '',
                                submenu: [
                                    {
                                        module: "Clienti",
                                        path: "marketing/task/contatto/0",
                                        title: "Aggiungi un Contatto",
                                        icon: "mdi mdi-account-group",
                                        capacita: ["menu-clienti"],
                                        class: ''
                                    },
                                    {
                                        module: "Marketing",
                                        path: "marketing/report-mail?stato=CA",
                                        title: "Crea Campagna per contattare i Clienti in stato Account",
                                        icon: "mdi mdi-account-group",
                                        capacita: [],
                                        class: ''
                                    }
                                ]
                            },
                            {
                                id: 'lead',
                                module: "Clienti",
                                path: "navigate/lead",
                                title: "- Lead",
                                icon: "mdi mdi-account-group",
                                capacita: ["menu-clienti"],
                                htmlText: '',
                                class: '',
                                submenu: [
                                    {
                                        module: "Clienti",
                                        path: "marketing/task/lead/0",
                                        title: "Aggiungi una Lead",
                                        icon: "mdi mdi-account-group",
                                        capacita: ["menu-clienti"],
                                        class: ''
                                    },
                                    {
                                        module: "Marketing",
                                        path: "marketing/report-mail?stati=CA,CT",
                                        title: "Crea Campagna per generare Lead",
                                        icon: "mdi mdi-account-group",
                                        capacita: [],
                                        class: ''
                                    }
                                ]
                            },
                            {
                                id: 'offerta-new-biz',
                                module: "Progetti",
                                path: "navigate/offerta-new-biz",
                                title: "- Sale Nuovo Cliente",
                                icon: "mdi mdi-account-group",
                                capacita: ["menu-progetti"],
                                htmlText: "",
                                class: '',
                                submenu: [
                                    {
                                        module: "Progetti",
                                        path: "marketing/offerta/0?classificazione=CL",
                                        title: "Aggiungi una Sale Nuovo Cliente",
                                        icon: "mdi mdi-account-group",
                                        capacita: [],
                                        class: ''
                                    },
                                    {
                                        module: "Clienti",
                                        path: "marketing/report-mail?stati=CA,CT,CL",
                                        title: "Crea Campagna per generare Sale Nuovo Cliente",
                                        icon: "mdi mdi-account-group",
                                        capacita: [],
                                        class: ''
                                    }
                                ]
                            },
                            {
                                id: 'offerta-upseilling',
                                module: "Progetti",
                                path: "navigate/offerta-upseilling",
                                title: "- Sale UpSelling",
                                icon: "mdi mdi-account-group",
                                capacita: ["menu-progetti"],
                                class: '',
                                submenu: [
                                    {
                                        module: "Progetti",
                                        path: "marketing/offerta/0?classificazione=CC",
                                        title: "Aggiungi una Sale Upseilling",
                                        icon: "mdi mdi-account-group",
                                        capacita: [],
                                        class: ''
                                    },
                                    {

                                        module: "Clienti",
                                        path: "marketing/report-mail?stato=CC",
                                        title: "Crea Campagna per generare Sale Upseilling",
                                        icon: "mdi mdi-account-group",
                                        capacita: [],
                                        class: ''
                                    }
                                ]
                            },
                        ]
                    },
                    {
                        id: 'pre-sales',
                        module: "Clienti",
                        path: "navigate/post-lead",
                        title: "Gestione Lead",
                        icon: "mdi mdi-account-group",
                        capacita: ["menu-clienti"],
                        class: 'has-arrow',
                        submenu:
                        [
                            {
                                id: 'R',
                                module: "Clienti",
                                path: '/task/task/edit/?type=C&tipo=235',
                                title: "- Call",
                                icon: "mdi mdi-account-group",
                                capacita: ["menu-clienti"],
                                class: ''
                              },
                              {
                                id: 'MC',
                                module: "Clienti",
                                path: '/task/task/edit/?type=C&tipo=239',
                                title: "- Meeting",
                                icon: "mdi mdi-account-group",
                                capacita: ["menu-clienti"],
                                class: ''
                              },
                              {
                                    id: 'R',
                                    module: "Clienti",
                                    path: '/task/task/edit/?type=C&tipo=238',
                                    title: "- Support",
                                    icon: "mdi mdi-account-group",
                                    capacita: ["menu-clienti"],
                                    class: ''
                                },
                        ]
                    },

                    {
                        id: 'care',
                        module: "Clienti",
                        path: "navigate/care",
                        title: "Gestione Acquirente",
                        icon: "mdi mdi-headset",
                        class: 'has-arrow',
                        capacita: [],
                        submenu: []
                    }
                ]
            },
            {
                module: "Clienti",
                path: "report",
                title: "Campagne",
                class: "has-arrow",
                icon: "mdi mdi-chart-line",
                capacita: ["menu-clienti"],
                submenu: [
                    {
                        module: "Marketing",
                        path: "marketing/report-mail",
                        title: "Mailing List",
                        icon: "mdi mdi-file-chart",
                        capacita: []
                    },

                ]
            },
             {
                module: "Clienti",
                path: "report",
                title: "Report",
                class: "has-arrow",
                icon: "mdi mdi-chart-line",
                capacita: ["menu-clienti"],
                submenu: [

                    {
                        module: "Marketing",
                        path: "marketing/report-campagne",
                        title: "Campagne",
                        icon: "mdi mdi-bullseye",
                        capacita: []
                    },
                    {
                        module: "Marketing",
                        path: "marketing/report-vendite",
                        title: "Sales",
                        icon: "mdi mdi-bullseye",
                        capacita: []
                    }
                ]
            }
        ]
    }
}
